import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { FileDownloadOutlined, Payment, WorkOutline } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { ClientDetails, ClientStatement } from "../../components/client";
import { PageHeader } from "../../components/v3";
import { ADD_CLIENT_INCOME, ADD_CLIENT_PAYMENT, GENERATE_CLIENT_REPORT, VIEW_CLIENT_STATEMENT } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleClient = () => {
  const [name, setName] = useState("");
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();

  const hasAddClientPayment = useHasPermission(ADD_CLIENT_PAYMENT);
  const hasAddClientIncome = useHasPermission(ADD_CLIENT_INCOME);
  const hasGenerateReport = useHasPermission(GENERATE_CLIENT_REPORT);
  const hasViewStatement = useHasPermission(VIEW_CLIENT_STATEMENT);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasAddClientPayment && {
      buttonText: "Add Payment",
      buttonIcon: Payment,
      onClick: () => navigate(`/receivables/add?clientId=${id}`),
    },
    hasAddClientIncome && {
      buttonText: "Cash In",
      buttonIcon: WorkOutline,
      onClick: () => navigate(`/add-income?clientId=${id}`),
    },
    hasGenerateReport && {
      buttonText: "Download Report",
      buttonIcon: FileDownloadOutlined,
      onClick: () => navigate(`/reports/client?clientId=${id}`),
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Client Details"
            // button
            buttons={buttons}
          />
        </Box>

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <ClientDetails onSuccess={setName} reloadData={reload} />
        </Box>

        {/* statement */}
        {hasViewStatement && <ClientStatement name={name} onSuccess={handleReload} reloadData={reload} />}
      </PageLayout>
    </>
  );
};
